
import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Getter } from 'vuex-class';

import ProductNoticeList from './../home/components/productNoticeList.vue';

// import noticeBanner from './../../assets/images/banner-notice.png';

@Component({
  components: { ProductNoticeList }
})
export default class NoticeList extends Vue {
  activeName: string = 'all';
  searchValue: string = '';
  currentPage: number = 1;
  PageSize: number = 10;
  params: { [key: string]: any } = {
    TypeID: '',
    keyword: '',
    SortList: [
      {
        SortField: 'ModifyOn', // ModifyOn ViewCount
        SortMode: 'DESC'
      }
    ],
    PageIndex: 1,
    PageSize: this.PageSize
  };

  @Getter noticeList: { [key: string]: any };
  @Getter typeNoticeList: { [key: string]: any };

  @Action getNoticeListByType: (params: object) => void;
  @Action getNoticeList: (params: object) => void;

  created() {
    // 获取tab分类
    this.getNoticeListByType({
      ...this.params,
      SortList: [
        {
          SortField: 'NewsType', // ModifyOn ViewCount
          SortMode: 'ASC'
        }
      ]
    });
  }

  mounted() {
    const { newsTypeGuid } = this.$route.params;
    this.activeName = newsTypeGuid || 'all';
    this.getNoticeList({
      ...this.params,
      TypeID: this.activeName === 'all' ? '' : this.activeName
    });
  }

  initParams() {
    return {
      ...this.params,
      TypeID: this.activeName === 'all' ? '' : this.activeName,
      keyword: this.searchValue,
      PageSize: this.PageSize,
      PageIndex: this.currentPage
    };
  }

  // 获取分类信息
  handleTabClick(tab: any, event: any) {
    // if (!this.searchValue) {
    this.currentPage = 1;
    this.activeName = tab.name || '';
    this.getNoticeList({
      ...this.initParams()
    });
    // }
  }

  onChange(value: string) {
    this.currentPage = 1;
    // this.searchValue = value;
    this.getNoticeList({
      ...this.initParams()
    });
  }

  handleSizeChange(value: number) {
    this.PageSize = value;
    this.getNoticeList({
      ...this.initParams()
    });
  }

  handleCurrentChange(value: number) {
    this.currentPage = value;
    this.getNoticeList({
      ...this.initParams()
    });
  }
}
